import React from 'react';
import {
  StyledMain,
  StyleBoxForm,
  StyledAlignRight,
  StyledTabsHorizontal,
  StyledTabHorizontal,
  StyledList,
  StyledElements,
  StyleInput,
  StyledBox,
  StyledRadioButton,
  StyledLabel,
  TitleButton
} from './style';
import {
  Section,
  TitleSection,
  TooltipElement
} from '../../../../core/AccordionTable/style';

import { StyleInputDate } from '../../../../core/EditionIRFP/style';

import AccordionDataSection from '../../../../core/AccordionTable/AccordionDataSection';
import Button from '../../../../core/Buttons';
import { StyledTitle } from '../../../../core/TitleGivens/style';

const IRPFData = ({ className, children }) => (
  <StyledMain className={className}>{children}</StyledMain>
);

const BoxForm = ({ className, children }) => (
  <StyleBoxForm className={className}>{children}</StyleBoxForm>
);

export {
  IRPFData,
  BoxForm,
  Section,
  TitleSection,
  TooltipElement,
  AccordionDataSection,
  Button,
  StyledTitle,
  TitleButton,
  StyledAlignRight,
  StyledTabsHorizontal,
  StyledTabHorizontal,
  StyledList,
  StyledElements,
  StyleInput,
  StyledBox,
  StyleInputDate,
  StyledRadioButton,
  StyledLabel
};
